<template>
  <object
    :data="!loading && url"
    type="application/pdf"
    class="step-preview-document"
    :class="{'loading-content': loading}"
  >
    <iframe :src="url">
      <p>Your browser does not support PDFs. <a :href="url">Download the PDF</a>.</p>
    </iframe>
  </object>
</template>

<script>
import {getCampaignStepPieces} from '../../../utility/api/campaign/getCampaignStepPieces';

export default {
  name: 'step-preview-document',
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
    stepId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      url: '',
    };
  },
  methods: {
    async getDocumentUrl() {
      const {data} = await getCampaignStepPieces(this.campaignId, this.stepId);
      const {content} = data.find(piece => piece.options && piece.options.input_type === 'document');
      this.url = content;
      this.loading = false;
    },
  },
  created() {
    this.getDocumentUrl();
  },
};
</script>

<style lang="scss" scoped>
.step-preview-document {
  position: absolute;
  left: 0;
  top: 50px;
  height: 100%;
  min-height: calc(100vh - 50px - var(--admin-bar-height, 0px));
  min-width: 100vw;
  width: 100%;

  iframe {
    height: 100%;
    width: 100%;
  }
}

.loading-content {
  background: center / 100px no-repeat url('/wp-content/themes/snappy-theme/assets/images/loading2.gif');
}
</style>
